import { Link } from 'react-router-dom';
import Icon from './AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const quickLinks = [
    { path: '/homepage', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/plumbing-services', label: 'Plumbing Services' },
    { path: '/electrical-services', label: 'Electrical Services' },
    { path: '/commercial-experience', label: 'Commercial Projects' }
  ];

  const serviceLinks = [
    { path: '/plumbing-services', label: 'Emergency Plumbing' },
    { path: '/plumbing-services', label: 'Pipe Repairs' },
    { path: '/plumbing-services', label: 'Water Heaters' },
    { path: '/electrical-services', label: 'Electrical Repairs' },
    { path: '/electrical-services', label: 'Installations' }
  ];

  const handlePhoneClick = () => {
    window.location.href = 'tel:0827935785';
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:info@meriodine.co.za';
  };

  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-12 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/homepage" className="flex items-center gap-2 text-primary font-bold text-xl mb-4">
              <Icon name="Wrench" size={28} color="var(--color-primary)" />
              <span className="font-headline">meriodine</span>
            </Link>
            <p className="text-muted-foreground mb-4 font-body">
              30+ years of trusted plumbing and electrical expertise serving residential and commercial clients across the region.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Facebook"
              >
                <Icon name="Facebook" size={20} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="Twitter"
              >
                <Icon name="Twitter" size={20} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <Icon name="Linkedin" size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-headline font-semibold text-foreground mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-muted-foreground hover:text-primary transition-colors font-body"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline font-semibold text-foreground mb-4">Services</h3>
            <ul className="space-y-2">
              {serviceLinks?.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link?.path}
                    className="text-muted-foreground hover:text-primary transition-colors font-body"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-headline font-semibold text-foreground mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={handlePhoneClick}
                  className="flex items-center gap-2 text-muted-foreground hover:text-accent transition-colors font-accent"
                >
                  <Icon name="Phone" size={18} />
                  <span>082 793 5785</span>
                </button>
              </li>
              <li>
                <button
                  onClick={handleEmailClick}
                  className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors font-body"
                >
                  <Icon name="Mail" size={18} />
                  <span>info@meriodine.co.za</span>
                </button>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground font-body">
                <Icon name="MapPin" size={18} className="mt-1 flex-shrink-0" />
                <span>Serving the Greater Region<br />24/7 Emergency Service</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-muted-foreground text-sm font-body">
              © {currentYear} meriodine. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link
                to="/privacy"
                className="text-muted-foreground hover:text-primary text-sm transition-colors font-body"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-muted-foreground hover:text-primary text-sm transition-colors font-body"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;